import geohash from 'ngeohash';

export const getGeohash = (latitude, longitude) => {
  return geohash.encode(latitude, longitude, 5); // Adjust precision as needed
};
